// src/utils/api/axios.js
import axios from "axios";

// 공통 axios 인스턴스 생성
const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || '', // 필요시 baseURL 지정
  timeout: 10000
});

// Request 인터셉터: 토큰 자동 추가
api.interceptors.request.use(
  function (config) {
    // 토큰 가져오는 방법: localStorage/sessionStorage/context 등
    const token = sessionStorage.getItem("apikey"); // 예시: 세션 스토리지에서 가져옴
    if (token) {
        config.headers["X-API-Key"] = token;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);


export default api;